import { render } from "./AppMenu.vue?vue&type=template&id=5676d7db"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=5676d7db&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__